
import { defineComponent, reactive, ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { clsUser } from '@/types/clsUser';

export default defineComponent({
  setup(_, context) {
    const router = useRouter()
    const internalInstance = getCurrentInstance()
    const refFrmLogin: any = ref(null)
    const message = ref('')
    const frmLogin = reactive({
      user_id: '',
      password: ''
    })
    const rules = {
      user_id: [
        { required: true, message: 'ユーザIDを入力してください。', trigger: 'blur' },
      ],
      password: [
        { required: true, message: 'パスワードを入力してください。', trigger: 'blur' },
      ]
    }
    const loginUser = new clsUser()
    const beforePage = history.state.back
    const login = () => {
      const api_path = internalInstance?.appContext.config.globalProperties.api_path
      refFrmLogin.value.validate((valid: boolean) => {
        if(valid) {
          fetch(api_path + 'ajax/login.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(frmLogin)
          })
          .then(response => response.json())
          .then(json => {
            if(json['result'] == 'failure') {
              throw new Error(json.error)
            }
            //console.log(json)
            message.value = ""
            loginUser.login = true
            loginUser.name = json['user_name']
            loginUser.email = json['address']
            loginUser.csrf = json['csrf']
            loginUser.admin_flg = json['admin_flg'] == '1'
            loginUser.validmail = json['validmail'] == '1'
            context.emit('login', loginUser)
            if(['/','/map'].includes(beforePage)) {
              router.push({ path: beforePage })  
            }else {
              router.push({ path: '/' })
            }
          })
          .catch(error => {
            console.error(error)
            message.value = error.message
          })
        }else {
          console.log('Did not submit.')
        }
      })
    }
    const back = () => {
      if(['/','/map'].includes(beforePage)) {
        router.push({ path: beforePage })  
      }else {
        router.push({ path: '/' })
      }
    }

    return {
      refFrmLogin,
      frmLogin,
      rules,
      back,
      login,
      message
    }
  }
})
